import { render, staticRenderFns } from "./power-skills.vue?vue&type=template&id=6f0ba9bc&scoped=true&"
import script from "./power-skills.vue?vue&type=script&lang=js&"
export * from "./power-skills.vue?vue&type=script&lang=js&"
import style0 from "./power-skills.vue?vue&type=style&index=0&id=6f0ba9bc&lang=scss&scoped=true&"
import style1 from "./power-skills.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0ba9bc",
  null
  
)

export default component.exports